import * as React from "react";
import './Pick.css';
import '../../components/Typograph.css';
import ImageRadioPicker from "../../components/ImageRadioPicker";
import {Luiksluiting} from "../../Model";
import typeFImage from '../../images/sluiting/luiksluitingF.jpg'
import typeAImage from '../../images/sluiting/luiksluitingA.jpg'
import typeDImage from '../../images/sluiting/luiksluitingD.jpg'
import macoImage from '../../images/sluiting/luiksluitingMaco.jpg'
import geenLuiksluitingImage from '../../images/sluiting/geen luiksluiting.jpg'
import oudhollandsImage from '../../images/sluiting/luiksluiting Oudhollands.jpg'
import traditioneelImage from '../../images/sluiting/luiksluiting traditioneel.jpg'
import enkelImage from '../../images/sluiting/enkele luiksluiting.jpg'
import otherImage from '../../images/template/other1.png'
import PropTypes from "prop-types";
import PhoneAppHeader from "../../components/PhoneAppHeader";
import PhoneAppFooter from "../../components/PhoneAppFooter";
import PickerInfoBox from "../../components/PickerInfoBox";

ClosingPick.propTypes = {
    handleNextPage: PropTypes.func.isRequired,
    handlePreviousPage: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    allValues: PropTypes.object.isRequired,
    disablePhoneMode: PropTypes.func.isRequired,
}

export default function ClosingPick(props) {
    const currentValue = props.allValues.ClosingPick;

    return (
        <div className="page">
            <PhoneAppHeader title="Luiksluiting"
                            quitPhoneApp={props.disablePhoneMode}
                            onPrevious={props.handlePreviousPage}/>

            <div className="phone-page-middle">
                <h1 className="phone-pick-title">Welke luiksluiting moet deze situatie krijgen?</h1>
                <h1 className="phone-pick-title-sub">Het is mogelijk dat uw voorkeur niet altijd te combineren is met uw aanvraag. In dat geval zullen wij u een passend alternatief advies geven.</h1>

                <div className="phone-pick-body">
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luiksluiting.TYPE_F}
                                      image={typeFImage}
                                      medium/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luiksluiting.TYPE_A}
                                      image={typeAImage}
                                      medium/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luiksluiting.TYPE_D}
                                      image={typeDImage}
                                      medium/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luiksluiting.OUDHOLLANDS}
                                      image={oudhollandsImage}
                                      medium/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luiksluiting.TRADITIONEEL}
                                      image={traditioneelImage}
                                      medium/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luiksluiting.ENKEL}
                                      image={enkelImage}
                                      medium/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luiksluiting.MACO}
                                      image={macoImage}
                                      medium/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      medium
                                      value={Luiksluiting.NO_CLOSING}
                                      image={geenLuiksluitingImage}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={{value: Luiksluiting.OTHER, text: ""}}
                                      child
                                      medium
                                      image={otherImage}/>
                </div>
            </div>

            <PickerInfoBox
                options={[
                    {value: Luiksluiting.TYPE_F, text: "Luiksluiting model F"},
                    {value: Luiksluiting.TYPE_A, text: "Luiksluiting model A"},
                    {value: Luiksluiting.TYPE_D, text: "Luiksluiting model D"},
                    {value: Luiksluiting.OUDHOLLANDS, text: "luiksluiting Oudhollands"},
                    {value: Luiksluiting.TRADITIONEEL, text: "luiksluiting traditioneel"},
                    {value: Luiksluiting.ENKEL, text: "enkele luiksluiting, alleen toe te passen bij enkele luiken kozijnmontage"},
                    {value: Luiksluiting.MACO, text: "Maco Rustico middensluiting"},
                    {value: Luiksluiting.NO_CLOSING, text: "Geen luiksluiting"},
                    {value: Luiksluiting.OTHER, text: "Omschrijf hier uw gewenste situatie", withInput: true},
                ]}
                current={currentValue}
                onChangeCurrent={props.handlePageChange}
                sticky
            />

            <PhoneAppFooter onNext={props.handleNextPage}
                            enableNext={!!currentValue}/>
        </div>
    );
}